export default __webpack_public_path__ + "static/media/icon_savings.f32c4140.svg";